import axios from 'axios';
import { useEffect, useState } from 'react';
import { Filter, Participant } from '../types/participant';

const useParticipants = (filter: Filter) => {
  const [participants, setParticipants] = useState<Participant[]>([]);

  const [offset, setOffset] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const [hasMorePosts, setHasMorePosts] = useState<boolean>(true);

  const fetchParticipants = async () => {
    let apiUrl = `/wp-json/joy/v1/participants?_wpnonce=${WP_VARS.nonce}`;

    if (filter) {
      apiUrl += `&${new URLSearchParams(filter)}`;
    }

    if (offset) {
      apiUrl += `&offset=${offset}`;
    }

    try {
      setLoading(true);
      const response = await axios.get(apiUrl);

      response.data.length < 11
        ? setHasMorePosts(false)
        : setHasMorePosts(true);

      setParticipants([...participants, ...response.data.slice(0, 10)]);
      setLoading(false);
    } catch (error: any) {
      setErrorMessage(error.code);
      setLoading(false);
    }
  };

  const loadMore = () => {
    setOffset((prevOffset) => prevOffset + 10);
  };

  useEffect(() => {
    fetchParticipants();
  }, [filter, offset]);

  return {
    participants,
    setParticipants,
    fetchParticipants,
    loading,
    errorMessage,
    loadMore,
    hasMorePosts,
    setOffset,
  };
};

export default useParticipants;
